<script>
  import { onMount } from "svelte";
  import Icon from "$lib/components/Icon.svelte";

  let clazz;
  export { clazz as class };
  export let iconSpacingClass = "gap-16";

  export let shareButtonsLabel = "Share";
  export let shareText = "I just checked this out! You should, too!";

  export let overrideURL; //Used for testing; Facebook and LinkedIn error on iFrames and Localhost
  // When this text is changed, also update the socialShare.spec.js e2e test.

  let socials;
  onMount(() => {
    let currentURL = overrideURL || window.location.href;
    socials = {
      // When these URLs are changed, also update the socialShare.spec.js e2e test.
      Facebook: `https://www.facebook.com/sharer/sharer.php?u=${currentURL}&src=sdkpreparse`,
      LinkedIn: `https://www.linkedin.com/sharing/share-offsite/?url=${currentURL}`
    };
  });

  function openNewWindow(social, w = 312, h = 500) {
    const left = window.screen.width / 2 - w / 2 + w;
    const top = window.screen.height / 2 - h;

    let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=${w},height=${h},left=-${left},top=${top}`;
    window.open(socials[social], shareText, params);
  }

  const handleClick = (social) => () => openNewWindow(social);

  const handleKeydown = (social) => (e) => {
    if (e?.key == "Enter" || e?.key == " ") {
      openNewWindow(social);
    }
  };

  const buttonClasses =
    "text-black w-24 h-24 md:w-48 md:h-48 rounded-full border-2 bg-white hover:bg-neutral-100 generic-focus focus:border-none focus:drop-shadow-[0_2px_0_#98DDFB] flex flex-col";
</script>

<div
  class={`flex flex-row items-center justify-center place-items-center gap-16 text-center ${clazz}`}
>
  {#if shareButtonsLabel}
    <div class="text-black font-bold text-size-12">{shareButtonsLabel}</div>
  {/if}

  {#if socials}
    <div class="flex {iconSpacingClass}">
      {#each Object.keys(socials) as social}
        <button
          class={buttonClasses}
          aria-label="Share to {social}.  Opens in a new window."
          on:click={handleClick(social)}
          on:keydown={handleKeydown(social)}
        >
          <Icon
            type={social.toLowerCase()}
            size="lg"
            inheritSize
            class="pt-[15%] pb-[15%] mx-auto"
          />
        </button>
      {/each}
    </div>
  {/if}
</div>
